var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-part4"},[_c('title1',{staticStyle:{"margin-top":"50px","font-size":"30px"},attrs:{"type":"2","title":"出租率"}}),_c('div',{staticClass:"p-content flex align-center mt-40"},[(_vm.show1)?_c('myEchart',{attrs:{"id":'show1',"options":_vm.batteryChargingData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }